import {observer} from 'mobx-react';
import React from 'react';
import {action, makeObservable, observable} from 'mobx';
import {RelatedProduct} from './related-products';

type Props = {
    product: RelatedProduct;
};

@observer
export default class ProductItem extends React.Component<Props> {
    @observable zoomImgUrl: string;

    constructor(props: Props) {
        super(props);
        this.getZoomImgUrl();
        makeObservable(this);
    }

    @action
    getZoomImgUrl() {
        const {src} = this.props.product;
        const split = src.split('/');
        const resolution = split[split.length - 1];
        const newResolution = resolution.replace(/0_\d+_\d+/, '0_800_800');

        this.zoomImgUrl = src.replace(resolution, newResolution);
    }

    render() {
        const {id, src, link, price} = this.props.product;
        const label = 'quick look';

        return (
            <div
                className="d-flex flex-column"
                style={{width: 160}}
            >
                <picture>
                    <source
                        type="image/webp"
                        srcSet={src.replace('.png', '.webp')}
                    />
                    <img
                        src={src}
                        alt={`Related Product-#${id}`}
                        loading="lazy"
                        width={160}
                        height={160}
                    />
                </picture>
                <div className="d-flex flex-row justify-content-between mt-2">
                    {window.innerWidth > 1200 ? (
                        <div
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-html="true"
                            data-bs-trigger="hover focus"
                            data-bs-content={`<img width="400" loading="lazy" src=${this.zoomImgUrl} alt="" />`}
                            style={{color: 'gray'}}
                        >
                            {label}
                        </div>
                    ) : (
                        <a href={link}>{label}</a>
                    )}
                    <strong>${price}</strong>
                </div>
            </div>
        );
    }
}
